<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <!-- logo -->
    <div class="logo">
      <img v-if="bannerArr.length > 0" :src="$imgUrl+bannerArr[0].thumb" alt="" />
    </div>
    <div class="exhibitorList_box">
      <div class="search_box">
        <div class="custom_sel">
          <el-select
            class="sel"
            v-model="search.session_expo"
            clearable
            :placeholder="langSet == 'cn' ? '届次选择' : 'Session Select'"
            @change="changeSearch"
          >
            <el-option
              v-for="(item, index) in sessionList"
              :key="index"
              :value="item.value"
              >{{ item.name }}</el-option
            >
          </el-select>

          <!-- <el-select
            class="sel ptype"
            v-model="search.type_1"
            clearable
            :placeholder="langSet == 'cn' ? '产品类型选择' : 'ProductType Select'"
            @change="changeSearch"
          >
            <el-option
              v-for="(item, index) in productTypeList"
              :key="index"
              :value="item.id"
              :label="langSet == 'cn' ? item.name_cn : item.name_en"
              >{{ langSet == "cn" ? item.name_cn : item.name_en }}</el-option
            >
          </el-select> -->
          <el-cascader
          clearable
           class="sel ptype"
            :placeholder="langSet == 'cn' ? '产品类型选择' : 'ProductType Select'"
            :props="cascaderProps"
            v-model="value"
            :options="productTypeList"
            @change="handleChange"
           ></el-cascader>
          <div class="zslb_box">
            <span class="zslb">{{ langSet == "cn" ? "展示类别" : "Display Category" }}：</span>
          <el-radio-group
            v-model="search.show_type"
            size="medium"
            v-for="(item, index) in showTypeList"
            :key="index"
            @input="changeSearch"
          >
            <el-radio-button
              :value="item.value"
              :label="langSet == 'cn' ? item.name : item.name_en"
            ></el-radio-button>
          </el-radio-group>
          </div>
        </div>
      </div>
      <div class="search_val">
        <div class="input_box">
          <input
            class="search_value"
            v-model="search.name_cn"
            type="text"
            :placeholder="
              langSet == 'cn' ? '搜索产品名称' : 'Search Product Name'
            "
          />
          <img class="input_icon" src="../../assets/search.jpg" />
        </div>
        <button class="custom_btn search_btn" @click="searchVal">
          {{ langSet == "cn" ? "查询" : "Search" }}
        </button>
        <button class="custom_btn reset_btn" @click="reset">
          {{ langSet == "cn" ? "重置" : "Reset" }}
        </button>
      </div>
      <div>
        <div class="ex_list"  v-loading="loading" v-if="companyList.length>0">
          <div
            class="ex_item"
            v-for="(item, index) in companyList"
            :key="index"
            @click="getproductDetail(item)"
          >
            <div class="ex_item_top">
              <div class="ex_title">
                {{ langSet == "cn" ? item.name_cn : item.name_en }}
              </div>
              <div class="ex_logo">
                <img class="ex_logo_img" :src="$imgUrl+item.imgs" alt="" />
              </div>
            </div>
            <div class="ex_tag_list">
              <div
                class="ex_tag_item"
                v-if="item.type_name1 || item.type_name1_en"
              >
                {{ langSet == "cn" ? item.type_name1 : item.type_name1_en }}
              </div>
              <div
                class="ex_tag_item"
                v-if="item.type_name2 || item.type_name2_en"
              >
                {{ langSet == "cn" ? item.type_name2 : item.type_name2_en }}
              </div>
            </div>
            <!-- <div class="ex_line"></div> -->
            <div class="ex_bottom_box">
              <div class="ex_detail">
                <span>{{ langSet == "cn" ? "查看详情" : "View Details" }}</span>
                <img class="more" src="../../assets/more.jpg" alt="" />
                <img class="more_sel" src="../../assets/more_sel.jpg" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="nodata_box" v-else>
                <nodata></nodata>
              </div>
        <div class="ex_footer">
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :page-size="search.page_size"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>
  
  <script>
import top from "../../components/top.vue";
import bottom from "../../components/bottom.vue";
import nodata from "../../components/nodata.vue";
import {
  getBanner,
  getproductList,
  getSessionList,
  getproductType,
  getshowType,
} from "@/api/api";
export default {
  components: { top, bottom ,nodata},
  name: "productList",
  // 配置title和meta数据
  metaInfo() {
    return {
      title: "BCEIA-产品列表",
      meta: [
        {
          name: "description",
          content: "产品列表产品列表产品列表",
        },
      ],
    };
  },
  data() {
    return {
      search: {
        page_no: 1,
        page_size: 10,
        session_expo: "",
        name_cn: "",
        type_1: "",
        type_2: "",
        show_type: "",
      },
      langSet: "",
      bannerArr: [],
      companyList: [],
      sessionList: [],
      total: 0,
      loading: false,
      productTypeList: [],
      showTypeList: [],
      cascaderProps: {
        value: 'id',
        label: '',
        children: 'children'
      }
    };
  },
  created() {},
  mounted() {
    this.langSet = localStorage.getItem("languageSet") || "cn";
    this.cascaderProps.label=this.langSet == 'cn' ?'name_cn' : 'name_en'
    this.getBannerList();
    this.getproductLists();
    this.getSession();
    this.getproduct();
    this.getshowType();
  },
  methods: {
    // zhang 跳转产品详情
    getproductDetail(item) {
      this.$router.push({
        name: "productDetail",
        query: {
          company_long_id: item.company_long_id,
          product_long_id: item.product_long_id,
        },
      });
    },
    // zhang 获取展商列表banner
    getBannerList() {
      let data = {
        class: "展商列表",
        lang_type: this.langSet,
      };
      getBanner(data)
        .then((res) => {
          if (res.code == 1) {
            this.bannerArr = res.data.lists;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // zhang 获取产品列表数据
    getproductLists() {
      this.loading = true;
      getproductList(this.search)
        .then((res) => {
          if (res.code == 1) {
            this.companyList = res.data.lists;
            this.total = res.data.count;
            this.loading = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    // zhang 获取展商列表届次
    getSession() {
      let data = {};
      getSessionList(data)
        .then((res) => {
          if (res.code == 1) {
            this.sessionList = res.data.lists;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // zhang 获取产品类型
    getproduct() {
      let data = {};
      getproductType(data)
        .then((res) => {
          if (res.code == 1) {
            this.productTypeList = res.data.lists;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // zhang 获取产品展示类别
    getshowType() {
      let data = {};
      getshowType(data)
        .then((res) => {
          if (res.code == 1) {
            this.showTypeList = res.data.lists;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // zhang 展商查询
    searchVal() {
      this.getproductLists();
    },
    // 重置
    reset() {
      this.search.session_expo = "";
      this.search.name_cn = "";
      this.search.type_1 = "";
      this.search.type_2 = "";
      this.search.show_type = "";
      this.search.page_no = 1;
      this.search.page_size = 10;
      this.getproductLists();
    },
    // 切换分页
    handleCurrentChange(val) {
      this.search.page_no = val;
      this.getproductLists();
    },
    // zhang 进去展商详情
    gotoDetail(item) {
      this.$router.push({
        path: "/exhibitorDetail",
        query: {
          company_long_id: item.company_long_id,
        },
      });
    },
    changeSearch(){
      this.getproductLists()
    },
    handleChange(val){
      if(val.length>0){
        this.search.type_1=""
        this.search.type_2=""
        if(val[0]!==undefined&&val[0]!==null&&val[0]!==''){
          this.search.type_1=val[0]
        }
        if(val[1]!==undefined&&val[1]!==null&&val[1]!==''){
          this.search.type_2=val[1]
        }

        this.getproductLists()
      }else{
        this.handleClear(); // 调用自定义清除方法
      }
    },
    handleClear() {
      console.log('清除按钮被点击');
       this.search.type_1=""
        this.search.type_2=""
        this.getproductLists()
      // 你可以在这里执行清除时需要做的操作
    }
  },
};
</script>
  
  <style lang="scss" scoped>
  .nodata_box{
    margin: 100px 0 50px;
  }
.logo {
  width: 100%;
  height: 600px;
  img {
    width: 100%;
    height: 600px;
  }
}
.custom_btn {
  width: 120px;
  height: 50px;
  border-radius: 8px;
  border: 1px solid #243889;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
}
.search_btn {
  background: #243889;
  border-radius: 8px;
  color: #ffffff;
  margin: 0 20px;
}
.reset_btn {
  background: #f7f8fa;
  color: #2c2c2e;
}
.exhibitorList_box {
  background: #fff;
  width: 1280px;
  margin: 50px auto 70px;
  .ex_footer {
    background: #fff;
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 50px;
  }
  .search_box {
    display: flex;
    .custom_sel {
      position: relative;
      margin-right: 20px;
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .sel::placeholder {
        color: #000 !important;
      }
      .ptype {
        margin: 0 30px;
      }
    }
  }
  .search_val {
    display: flex;
    margin-top: 20px;
    .input_box {
      position: relative;
      .input_icon {
        position: absolute;
        left: 20px;
        top: 15px;
        width: 20px;
        height: 20px;
      }
    }
  }
  .ex_tips {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    margin: 20px 0 10px;
  }
  .ex_list {
    display: flex;
    flex-wrap: wrap;
    //justify-content: space-between;
    margin-top: 50px;
    .ex_item {
      cursor: pointer;
      width: -webkit-calc((100% - 23px * 5)/ 5);
      width: calc((100% - 23px * 5) / 5);
      margin: 0 20px 20px 0;
      background: rgba(171, 181, 205, 0.1);
     
      border: 1px solid rgba(171, 181, 205, 0.1);
      display: flex;
      flex-wrap: wrap;
      &:nth-child(5n) {
        margin-right: 0;
      }
      .ex_item_top {
        padding: 15px;
        width: 100%;
        box-sizing: border-box;
        .ex_title {
          width: 100%;
          height: 40px;
          line-height: 22px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 16px;
          color: #2c2c2e;
        }
        .ex_logo {
          width: 100%;
          height: 115px;
          margin: 10px 0;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #fff;
          .ex_logo_img {
            max-width: 90%;
            max-height: 90%;
          }
        }
      }
      .ex_tag_list {
        // display: flex;
        // flex-wrap: wrap;
        padding: 0 15px;
        width: 100%;
        box-sizing: border-box;
        .ex_tag_item {
          // width: 64px;
          padding: 0 8px;
          box-sizing: border-box;
          // min-height: 21px;
          line-height: 21px;
          text-align: center;
          background: rgba(36, 56, 137, 0.1);
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 12px;
          color: #243889;
          margin-right: 8px;
          margin-bottom: 8px;
          display: inline-block;
        }
      }
      .ex_line {
        width: 100%;
        height: 1px;
        background: #eeeeee;
      }

      .img {
        width: 100%;
        height: 105px;
      }
      .ex_address {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #757575;
        margin-top: 5px;
      }
      .ex_bottom_box {
        width: 100%;
        margin-top: 15px;
        padding-top: 15px;
        padding-bottom: 15px;
        padding-left: 15px;
        box-sizing: border-box;
        align-self: flex-end;
        border-top: 1px solid #eeeeee;
        .ex_booth {
          display: flex;
          img {
            width: 13px;
            height: 18px;
          }
          span {
            display: inline-block;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #2c2c2e;
            margin-left: 8px;
          }
        }
        .ex_detail {
          cursor: pointer;
          span {
            display: inline-block;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #757575;
          }
          img {
            width: 7px;
            height: 10px;
            margin-left: 6px;
          }
          .more_sel{
            display: none;
          }
        }
      }
    }
    .ex_item:hover{
            border: 1px solid #243889;
            .ex_detail{
                span{
                color: #243889;
              }
              .more{
                display: none;
              }
                .more_sel{
                    display: inline-block;
                  }
              }

        }
  }
  .ex_list::after {
    content: "";
    flex: auto;
  }
  .search_value {
    width: 680px;
    height: 50px;
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid #dddddd;
    padding-left: 55px;
    box-sizing: border-box;
  }
  .search_value::placeholder {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
  }
}
@media only screen and (max-width: 1280px) {
  .ex_item {
      width: -webkit-calc((100% - 23px * 4)/ 4) !important;
      width: calc((100% - 23px * 4) / 4) !important;
      margin: 0 20px 20px 0 !important;
  }
  .exhibitorList_box {
    width: 90%;
    .ex_list .ex_item .ex_item_top .ex_logo {
      width: 100%;
    }
  }
}
@media only screen and (max-width: 1000px) {
  .ex_item {
      width: -webkit-calc((100% - 23px * 3)/ 3) !important;
      width: calc((100% - 23px * 3) / 3) !important;
      margin: 0 20px 20px 0 !important;
  }
  .exhibitorList_box {
    width: 95%;
    .ex_list .ex_item .ex_item_top .ex_logo {
      width: 100%;
    }
    .search_box .custom_sel .ptype {
      margin: 0 10px;
    }
    .el-radio-group {
      margin-right: 5px;
    }
    .search_box .custom_sel {
      margin-right: 0;
    }
    .search_value {
      width: 100%;
    }
    .search_val .input_box {
      flex: 1;
    }
  }
}
@media only screen and (max-width: 767px) {
  // .ex_item {
  //     width: -webkit-calc((100% - 23px * 2)/ 2) !important;
  //     width: calc((100% - 23px * 2) / 2) !important;
  //     margin: 0 20px 20px 0 !important;
  // }
  .logo {
    height: auto;
    margin-top: 0.88rem;
    img {
      height: auto;
    }
  }
  .exhibitorList_box {
    width: 92%;
    margin: 30px auto;
   
    .ex_list .ex_item .ex_item_top .ex_logo {
      width: 100%;
    }
    .search_box .custom_sel .ptype {
      margin: 0 0 15px 0;
    }
    .el-select {
      margin-bottom: 15px;
    }
    .el-radio-group {
      margin-right: 3px;
      margin-bottom: 5px;
    }
    .zslb_box{
      margin-top: 8px;
    }
    .zslb{
      font-size: 14px;
    }
    .search_box .custom_sel {
      margin-right: 0;
    }
    .search_value {
      width: 100%;
      height: 35px;
      padding-left: 30px;
      border-radius: 5px;
    }
    .search_val .input_box {
      flex: 1;
    }
    .search_val .input_box .input_icon {
      top: 10px;
      left: 10px;
      width: 15px;
      height: 15px;
    }
    .custom_btn {
      width: 65px;
      height: 35px;
      font-size: 14px;
      margin: 0 5px;
      border-radius: 5px;
    }
    .ex_list {
      margin-top: 30px;
      justify-content: space-between;
      .ex_item {
        width: 47.5% !important;
        margin: 0 0px 20px 0 !important;
        .ex_item_top {
          .ex_title {
            font-size: 15px;
          }
          .ex_logo {
            height: 100px;
            margin-bottom: 0;
          }
        }
        .ex_bottom_box {
          margin-top: 10px;
          padding: 10px 15px;
        }
      }
    }
    .ex_footer {
      width: 100%;
      margin-top: 30px;
      .el-pager li {
        font-size: 12px;
      }
    }
  }
}
</style>
  <style>
.exhibitorList_box .el-select {
  width: 200px;
  height: 50px;
}
.exhibitorList_box .el-select .el-input__inner {
  height: 50px;
  background: #f7f8fa;
  border-radius: 8px;
  border: none;
}
.exhibitorList_box .el-select > .el-input {
  height: 50px;
}
.exhibitorList_box .el-select .el-input .el-select__caret {
  color: #000;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #243889;
  border-radius: 4px;
  border: 1px solid #243889;
}
.el-radio-group {
  margin-right: 20px;
}
.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: #243889;
  border-color: #243889;
}
.el-radio-button__inner:hover {
  color: #606266;
}
@media only screen and (max-width: 767px) {
  .exhibitorList_box .search_val {
    margin-top: 10px;
  }
  .exhibitorList_box .el-select {
    height: 35px;
  }
  .exhibitorList_box .el-select > .el-input {
    height: 39px;
  }
  .exhibitorList_box .el-select .el-input__inner {
    height: 35px;
    border-radius: 5px;
  }
  .el-radio-button--medium .el-radio-button__inner {
    padding: 4px;
    font-size: 12px;
  }
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    min-width: 24px;
  }
}
</style>